import {
    getLocationBridge,
    getLoginInfoBridge,
    redirectToLoginViewBridge
} from '@/util/platform/universal';

let location$ = null;

export async function getLocation() {
    {
        if (!location$) {
            location$ = new Promise((resolve, reject) => {
                getLocationBridge()
                    .then(res => {
                        if (res.result_code === 'success') {
                            console.log('current location:', res.data);
                            return resolve(res.data || {});
                        } else {
                            reject(
                                new Error(
                                    `Locate from app error ${res.display_message}`
                                )
                            );
                        }
                    })
                    .finally(() => {
                        location$ = null;
                    });
            });
        }
        return location$;
    }
}

export async function getLoginInfo(params = { autoJump: false }) {
    console.log("[app getLoginInfo]", params)
    const res = await getLoginInfoBridge();

    if (params.autoJump && (!res.data || !res.data.access_token)) {
        return redirectToLoginViewBridge();
    }
    return res;
}



// WEBPACK FOOTER //
// ./src/util/platform/app.js